import { BookOpenText, CircleDot, FileText, Layers, Repeat } from "lucide-react";
import { SectionCard } from "../Domain/domainIntelligenceParts";
import { humaniseFlag } from "./utilities";
import { InsightTile } from "./conceptIntelligenceParts";

export interface ExtractionSummaryProps {
  total: number;
  definedSections: string[];
  definedCount: number;
  definedCoveragePct: number;
  recurringCount: number;
  topRecurringName: string;
  groupsCount: number;
  groupingPass?: string;
  ungrouped: number;
  truncated: number;
  findingsReturned: number;
}

export function ExtractionSummarySection({
  total,
  definedSections,
  definedCount,
  definedCoveragePct,
  recurringCount,
  topRecurringName,
  groupsCount,
  groupingPass,
  ungrouped,
  truncated,
  findingsReturned,
}: ExtractionSummaryProps) {
  return (
    <SectionCard
      headerLabel="Extraction summary"
      rightLabel="Governance vocabulary"
    >
      <div className="grid grid-cols-2 gap-3 p-4 md:grid-cols-3 lg:grid-cols-5">
        <InsightTile
          icon={Layers}
          tone="cyan"
          value={total}
          label="Total concepts"
          hint={`Across ${definedSections.length} ${definedSections.length === 1 ? "section" : "sections"
            }`}
        />
        <InsightTile
          icon={BookOpenText}
          tone="indigo"
          value={definedCount}
          label="Defined terms"
          hint={`${definedCoveragePct}% of concepts`}
        />
        <InsightTile
          icon={Repeat}
          tone="violet"
          value={recurringCount}
          label="Recurring terms"
          hint={
            recurringCount > 0
              ? `Top: ${topRecurringName}`
              : "None observed"
          }
        />
        <InsightTile
          icon={CircleDot}
          tone="amber"
          value={groupsCount}
          label="Groups"
          hint={`Grouping ${humaniseFlag(groupingPass).toLowerCase()}${ungrouped ? ` \u00b7 ${ungrouped} ungrouped` : ""
            }`}
        />
        <InsightTile
          icon={FileText}
          tone="slate"
          value={truncated}
          label="Findings truncated"
          hint={`Of ${findingsReturned} returned`}
        />
      </div>
    </SectionCard>
  );
}
